<div class="container-space-between">
  <app-page-title
    [title]="translations.title"
    [backText]="translations.titleBackText"
    [goBackRoute]="routingEnum.ADMIN"
  ></app-page-title>
</div>

@if (isLoading()) {
  <app-loader></app-loader>
} @else {
  <app-settings-list
    [allSettingGroups]="allSettingGroups()"
    [isShowDescription]="true"
  ></app-settings-list>
}
